import {Address} from "./model";

export interface AddressOption {
    label: string
    value: Address
}

export interface Params {
    addressOptions: [{address: Address}];
}

export const DeDuplicateAddressOptions = ({addressOptions}: Params): AddressOption[] => {
    type valueMap = {[key: string]: any}
    const values: valueMap = {}

    // Just overwrite the values, as it doesn't matter which one we use
    addressOptions.forEach(node => {
        let label = `${node.address.street1} ${node.address.city}, ${node.address.state} ${node.address.postalCode}`
        values[label] = node.address
    })


    return Object.keys(values).map(label => {return {label: label, value: values[label]}})
}